import { render, staticRenderFns } from "./PlusBoxMultiple.vue?vue&type=template&id=5764b316&"
import script from "./PlusBoxMultiple.vue?vue&type=script&lang=js&"
export * from "./PlusBoxMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports